export {
  type GetUserSettingsQuery,
  type GetUserSettingsQueryVariables,
  type UpdateUserSettingsMutation,
  type UpdateUserSettingsMutationVariables,
  useGetUserSettingsQuery,
  useLazyGetUserSettingsQuery,
  api as userSettingsApi,
} from './operations.generated';

export { useUpdateUserSettingsMutation } from './userSettings.api';
